import * as React from "react";
import { IAIcon } from "../../../icon/Icon";
import { IASpinner } from "../../../spinner/Spinner";
import * as styles from "./ProgressListItem.css";

export interface IProgressListItemProps {
  label: string;
  step: number;
  isCompleted: boolean;
  isRunning: boolean;
  isFailed: boolean;
  requiresAttention: boolean;
}

export interface IProgressListItemState {
  isCompleted: boolean;
  isRunning: boolean;
  isFailed: boolean;
  requiresAttention: boolean;
}

export class ProgressListItem extends React.Component<IProgressListItemProps, IProgressListItemState> {
  constructor(props: IProgressListItemProps) {
    super(props);
    this.state = {
      isCompleted: props.isCompleted,
      isRunning: props.isRunning,
      isFailed: props.isFailed,
      requiresAttention: props.requiresAttention
    }
  }

  public componentDidUpdate(prevProps): void {
    if (prevProps.isCompleted !== this.props.isCompleted || prevProps.isRunning !== this.props.isRunning || prevProps.isFailed !== this.props.isFailed || prevProps.requiresAttention !== this.props.requiresAttention) {
      this.setState({
        isCompleted: this.props.isCompleted,
        isRunning: this.props.isRunning,
        isFailed: this.props.isFailed,
        requiresAttention: this.props.requiresAttention
      });
    }
  }

  public render(): JSX.Element {
    return (
      <div className={styles.IProgressList_Item}>
        <div
          className={styles.spinner}
        >
          {this.state.isRunning && !this.state.isCompleted && !this.state.isFailed &&
            <IASpinner
              style={{
                marginTop: 3,
                width: 20,
                height: 20
              }}
            />
          }
          {this.state.isCompleted && !this.state.isFailed && !this.state.requiresAttention &&
            <IAIcon
              title="Checkmark"
              size={20}
              color={"#23879b"}
            />
          }
          {this.state.isCompleted && !this.state.isFailed && this.state.requiresAttention &&
            <IAIcon
              title="Attention"
              size={20}
              color={"#ff9966"}
            />
          }
          {this.state.isFailed &&
            <IAIcon
              title="Close"
              size={20}
              color={"#ff0000"}
            />
          }
        </div>
        <span style={this.state.isRunning || this.state.isCompleted || this.state.isFailed ? { fontWeight: "bold" } : undefined}>
          {this.props.label}
        </span>
      </div>
    )
  }
}